import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  // Vite's replacement for webpack's require.context: bulk-import every locale
  // JSON eagerly, keyed by path (e.g. './locales/en.json').
  const locales = import.meta.glob('./locales/*.json', { eager: true, import: 'default' })
  const messages = {}
  Object.keys(locales).forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\.json$/i)
    if (matched && matched.length > 1) {
      messages[matched[1]] = locales[key]
    }
  })
  return messages
}

export default new VueI18n({
  locale: localStorage.getItem('lang') || 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
})
